// Init User (and refresh token) if token is in cookies

export async function initAuth() {
  if (await this.hasValidToken()) {
    return this.initUser()
  }

  return null
}
